<script>
import dateMixin from "@/mixins/dateMixin";
import cycleStates from "@/utils/states/cycle";

export default {
  props: {
    cycle: {
      type: Object,
      required: true
    }
  },
  mixins: [dateMixin],
  data() {
    return {
      state: null
    };
  },
  methods: {
    isInPaymentStatus() {
      return cycleStates.isInPaymentStatus(this.cycle.status);
    }
  },
  mounted() {
    this.state = cycleStates.getState(this.cycle.status);
  }
};
</script>

<template>
  <section v-if="state">
    <div class="chip mb-10" :class="state.color">{{state.name}}</div>
    <b>{{cycle.starts_at | formatDate('DD [de] MMM/Y')}}</b>
    até
    <b>{{cycle.ends_at | formatDate('DD [de] MMM/Y')}}</b>

    <div class="row">
      <router-link
        v-if="isInPaymentStatus()"
        :to="{name: 'cycle-checkout', params: {cycle_id: cycle.id}}"
        class="btn-payment mt-10"
      >pagar</router-link>
      <router-link :to="{name: 'cycle', params: {id: cycle.id}}" class="details mt-10">ver detalhes</router-link>
    </div>
  </section>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f9f9f9;
  width: 203px;
  border-radius: 4px;
  padding: 20px 0;
  margin: 5px;
  font-size: 14px;
  transition: all 0.24s ease;
}

section:hover {
  transform: scale(1.05);
}

.btn-payment {
  background-color: var(--green);
  padding: 8px 13px;
  color: #fff;
  border-radius: 20px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.24s ease;
  margin-right: 5px;
}
.btn-payment:hover {
  background-color: var(--green-dark);
}

.details {
  background-color: #eee;
  padding: 8px 13px;
  color: #333;
  border-radius: 20px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.24s ease;
}

.details:hover {
  background-color: #ddd;
}

.chip {
  transition: all 0.24s ease;
}
.chip:hover {
  transform: translateY(-5px);
}

@media (max-width: 992px) {
  section {
    width: 197px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Subscriptions/Subscription/Cycles/Card.vue